import TableEdit from './components/TableEdit';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'tableEdit',
  pluginComponent: TableEdit,
});
